// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

const Wrapper = styled('div')`
  padding: 8px;
  height: 90vh;
  display: flex;
  flex-direction: column;
`

const Header = styled.div`
  color: ${colors.blue500};
  font-size: 16px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${colors.blue500};
  position: relative;
  height: 32px;
`

const ContentWrapper = styled('div')`
  flex: 1;
  align-items: center;
  background-color: ${colors.blue100};
  color: ${colors.blue200};
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  padding: 20px;

  > span {
    font-size: 10px;
    margin: 16px 0 4px 0;
  }
`

const Content = styled('div')`
  background-color: white;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.2),
    0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 2px 1px -1px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  div:first-child {
    align-items: center;
    border-bottom: 1px solid ${colors.gray210};
    color: ${colors.black};
    display: flex;
    font-size: 20px;
    font-weight: 500;
    min-height: 64px;
    padding: 8px 32px;
  }

  iframe {
    border: none;
    flex: 1;
    width: 100%;
  }

  div:last-child {
    font-weight: 500;
    margin-bottom: 16px;
    margin-top: auto;
    text-align: center;
  }

  body {
    background-color: unset;
    color: ${colors.blue200};
  }

  img {
    width: 100%;
  }
`

export { Content, ContentWrapper, Header, Wrapper }
